import request from '@/utils/request'

export function getCompetitionArchiveOverview(studentId) {
  return request({
    url: '/competition-archive/overview',
    method: 'get',
    params: { studentId }
  })
}

export function getCompetitionArchiveDetail(archiveId) {
  return request({
    url: `/competition-archive/${archiveId}`,
    method: 'get'
  })
}

export function saveCompetitionArchive(data) {
  return request({
    url: '/competition-archive/save',
    method: 'post',
    data
  })
}

export function reviewCompetitionArchive(data) {
  return request({
    url: '/competition-archive/review',
    method: 'post',
    data
  })
}

export function deleteCompetitionArchive(archiveId) {
  return request({
    url: `/competition-archive/${archiveId}`,
    method: 'delete'
  })
}

export function uploadCompetitionArchiveFile(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/file/uploadTo/question-info',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
